var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInviteFriends = function SvgInviteFriends(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-26.5%",
    y: "-26.5%",
    width: "152.9%",
    height: "152.9%",
    filterUnits: "objectBoundingBox",
    id: "invite_friends_svg__c"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.021 0C3.144 0 0 3.165 0 7.07c0 3.904 3.144 7.07 7.021 7.07 3.878 0 7.022-3.166 7.022-7.07 0-1.875-.74-3.673-2.057-5A6.997 6.997 0 0 0 7.021 0Zm.002 9.57-2.5-2.5 2.5-2.5 2.5 2.5-2.5 2.5Z",
    id: "invite_friends_svg__a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.957 4.86)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 7.043,
    cy: 7.14,
    r: 4
  }), /*#__PURE__*/React.createElement("mask", {
    id: "invite_friends_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#invite_friends_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#E7DCFE",
    xlinkHref: "#invite_friends_svg__a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.021.282c1.787 0 3.501.715 4.765 1.988a6.812 6.812 0 0 1 1.974 4.8 6.79 6.79 0 0 1-1.974 4.8 6.694 6.694 0 0 1-4.765 1.987c-1.86 0-3.545-.76-4.764-1.987a6.79 6.79 0 0 1-1.975-4.8 6.79 6.79 0 0 1 1.975-4.8A6.694 6.694 0 0 1 7.02.282Zm0 3.603L3.87 7.06l3.151 3.173 3.152-3.173L7.02 3.885Z",
    stroke: "#D5BDFF",
    strokeWidth: 0.565,
    fill: "#E7DCFE",
    opacity: 0.401,
    mask: "url(#invite_friends_svg__b)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6F40EE",
    filter: "url(#invite_friends_svg__c)",
    mask: "url(#invite_friends_svg__b)",
    cx: 3.5,
    cy: 4.5,
    r: 8.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.021.282c1.787 0 3.501.715 4.765 1.988a6.812 6.812 0 0 1 1.974 4.8 6.79 6.79 0 0 1-1.974 4.8 6.694 6.694 0 0 1-4.765 1.987c-1.86 0-3.545-.76-4.764-1.987a6.79 6.79 0 0 1-1.975-4.8 6.79 6.79 0 0 1 1.975-4.8A6.694 6.694 0 0 1 7.02.282Z",
    stroke: "#D5BDFF",
    strokeWidth: 0.565,
    fill: "#E7DCFE",
    opacity: 0.401,
    mask: "url(#invite_friends_svg__b)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.504 10.605c.15-4.184 3.37-7.553 7.41-7.753C10.693 1.01 8.522.104 6.406.557c-2.116.453-3.762 2.176-4.177 4.37-.415 2.194.482 4.432 2.276 5.678ZM5.705 16.628c-1.116-.18-1.863-.599-2.22-1.284-.623-1.17.024-2.796.03-2.81a.768.768 0 0 0-.257-.917.692.692 0 0 0-.908.093L.206 13.979a.773.773 0 0 0 .007 1.058.693.693 0 0 0 1.012-.007l.572-.599c.027.572.176 1.13.435 1.635.572 1.101 1.677 1.796 3.257 2.047a.72.72 0 0 0 .112 0 .706.706 0 0 0 .655-.321.78.78 0 0 0 .055-.755.718.718 0 0 0-.601-.42l-.005.01ZM13.717 1.934c1.008-.473 1.838-.521 2.467-.145 1.091.658 1.361 2.428 1.364 2.428.05.36.329.631.663.643h.025c.33-.002.613-.255.68-.606l.646-3.155c.071-.404-.165-.796-.532-.885-.368-.09-.734.156-.827.554l-.173.838a3.731 3.731 0 0 0-1.167-1.16C15.84-.16 14.597-.16 13.168.522c-.342.175-.495.615-.344.993.151.377.55.555.901.4l-.008.02Z",
    fill: "#6F40EE"
  }))));
};
export default SvgInviteFriends;